export class Validate {
    constructor(selector) {
        this.isOkey = true;

        this.block = {
            main: 'validate',
            body: 'validate__body',
        };

        this.removeIsExist(`.${this.block.body}`);

        const currentStep = document.querySelector(selector);

        const texts = currentStep.querySelectorAll('input[type="text"]');
        const emails = currentStep.querySelectorAll('input[type="email"]');
        const numbers = currentStep.querySelectorAll('input[type="number"]');
        const inputs = [...texts, ...emails, ...numbers];

        const validate = currentStep.querySelector(`.${this.block.main}`);
        const list = document.createElement('ul');

        list.classList.add(this.block.body);

        inputs.forEach( input => {
            const value = input.value;
            input.classList.remove('validate--error');
            if (this.isOkey) {
                if (!Boolean(value)) {
                    let id = input.id;
                    const li = document.createElement('li');

                    if (input.classList.contains('hasDatepicker')){
                        id = input.previousElementSibling.id;
                    }

                    const label = currentStep.querySelector(`label[for="${id}"]`).textContent;

                    li.innerHTML = `Pole <b>${label}</b> wymaga uzupełnienia`;
                    list.appendChild(li);

                    validate.appendChild(list);

                    input.classList.add('validate--error');
                    this.isOkey = false;
                }
            }

            input.addEventListener('blur', (event) => {
                const value = input.value;
                if (Boolean(value)){
                    input.classList.replace('validate--error','validate--success');
                    this.clearValidate();
                }
            });
        })
    }
    clearValidate(){
        this.removeIsExist(`.${this.block.body}`);
    }

    removeIsExist(selectors) {
        const elements = document.querySelectorAll(selectors);
        elements.forEach( (element) => {
            if (element) {
                element.remove();
            }
        });
    }
}